import { type ReactNode } from 'react'
import { Typography } from 'shared/ui'

import styles from './styles.module.scss'

type IRcsViewSectionProps = {
  title: string
  children: ReactNode
}

type IRcsViewValueProps = {
  children: ReactNode
}

type IRcsViewLinkProps = {
  href: string
}

type IRcsMediaValueProps = {
  url: string
  isVideo?: boolean
}

export const RcsViewSection = ({ title, children }: IRcsViewSectionProps) => (
  <section className={styles.section}>
    <Typography
      variant='body-md-medium'
      className={styles.sectionTitle}
      ariaLabel='RcsViewSection_title'
    >
      {title}
    </Typography>
    <div className={styles.sectionContent}>{children}</div>
  </section>
)

export const RcsViewValue = ({ children }: IRcsViewValueProps) => (
  <Typography
    variant='text-input-field-r'
    color='var(--content-primary-primary)'
    className={styles.value}
    ariaLabel='RcsViewValue_text'
  >
    {children}
  </Typography>
)

export const RcsViewLink = ({ href }: IRcsViewLinkProps) => (
  <Typography
    variant='text-input-field-r'
    color='var(--content-primary-primary)'
    className={styles.value}
    ariaLabel='RcsViewValue_link'
  >
    <a className={styles.link} href={href} target='_blank' rel='noopener noreferrer'>
      {href}
    </a>
  </Typography>
)

export const RcsMediaValue = ({ url, isVideo }: IRcsMediaValueProps) => {
  const fileName = url.split('/').pop()?.split('?')[0] ?? url

  return (
    <div className={styles.mediaValue}>
      {isVideo ? (
        <video className={styles.mediaThumb} src={`${url}#t=0.1`} muted preload='metadata' />
      ) : (
        <img className={styles.mediaThumb} src={url} alt='' />
      )}
      <Typography
        variant='text-input-field-r'
        color='var(--content-primary-primary)'
        ellipsis
        width='100%'
        tooltipProps={{ label: fileName }}
        ariaLabel='RcsMediaValue_name'
      >
        {fileName}
      </Typography>
    </div>
  )
}
